import React from 'react';

import { Typography } from '@mui/material';

import { StyledBlockQuote } from './BlockQuoteStyles';

/**
 * Renders a blockquote tag in rich text
 *
 * @param {{value: string}[]} content
 *
 * @returns {React.ReactElement}
 */
function BlockQuote({ content }) {
  return (
    <StyledBlockQuote>
      {content.map(item => (
        <Typography key={`rich-text-block-quote-${item.value}`} variant="DS_copyMediumRegular" component="span">
          {`"${item.value}"`}
        </Typography>
      ))}
    </StyledBlockQuote>
  );
}

export default BlockQuote;
